import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import RequestsNavigationIcon from 'Icons/NavigationItem/Requests';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';

const LazyRequestSettingsPage = React.lazy(() => import('./Pages'));

const requestSettingsConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:system.requests.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.system.requests.title',
            url: '/request-settings',
            Icon: RequestsNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyRequestSettingsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
};

export default requestSettingsConfiguration;
